import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import IndustriesPage from "./pages/IndustriesPage";
import ADRPage from "./pages/ADRPage";
import SolutioPage from "./pages/SolutioPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A] text-white">
      <LanguageProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/o-nas" element={<AboutPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/uslugi" element={<ServicesPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/branze" element={<IndustriesPage />} />
            <Route path="/industries" element={<IndustriesPage />} />
            <Route path="/adr" element={<ADRPage />} />
            <Route path="/solutio" element={<SolutioPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
